export const extractErrorMessage = async (err, defaultMessage = "An error occurred.") => {
    try {
        if (err.response && err.response.data) {
            // If the response is a blob, read it as text
            if (err.response.data instanceof Blob) {
                const text = await err.response.data.text();
                // Try treating as JSON first
                try {
                    const json = JSON.parse(text);
                    if (json.error) return `${defaultMessage} Details: ${json.error}`;
                    if (json.message) return `${defaultMessage} Details: ${json.message}`;
                } catch (e) {
                    return `${defaultMessage} Details: ${text}`;
                }
            }

            // If the response is already JSON
            if (err.response.data.error) {
                return `${defaultMessage} Details: ${err.response.data.error}`;
            }
            if (err.response.data.message) {
                return `${defaultMessage} Details: ${err.response.data.message}`;
            }

            // Fallback for string response data
            if (typeof err.response.data === 'string') {
                return `${defaultMessage} Details: ${err.response.data}`;
            }
        } else if (err.message) {
            return `${defaultMessage} Details: ${err.message}`;
        }
    } catch (parseError) {
        // Unparseable error body — fall through to the caller's default message.
    }
    return defaultMessage;
};
